/*
 * @Author: 秦少卫 nihaojob@163.com
 * @Date: 2025-05-27 09:28:28
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-08-09 17:12:18
 * @FilePath: /kuaitu/src/router/podRoutes.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { RouteRecordRaw } from 'vue-router';

// import Layout from '@/views/admin/index.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/shopLogin',
    component: () => import('@/views/shopLogin/index.vue'),
  },
  // {
  //   path: '/shopAdmin',
  //   component: () => import('@/views/shopAdmin/index.vue'),
  // },
  {
    path: '/shopAdmin',
    // component: Layout,
    component: () => import('@/views/shopAdmin/index.vue'),
    redirect: '/shopAdmin/order',
    children: [
      {
        path: 'shop',
        component: () => import('@/views/shopAdmin/shopManage/index.vue'),
      },
      {
        path: 'order',
        component: () => import('@/views/shopAdmin/orderManage/index.vue'),
      },
    ],
    // shopManage/shopOrder
  },
];

export default routes;
